export default __webpack_public_path__ + "static/media/Let the Show Begin.d04051ff.png";